<template>
  <div>
    <div class="coupon-list-window" :class="value === true ? 'on' : ''">
      <div class="title">
        抵用券
        <span class="iconfont icon-guanbi" @click="close"></span>
      </div>
      <div v-if="voucherList.length > 0">
        <div class="coupon-list">
          <div
            class="item acea-row row-center-wrapper"
            style="height: 1.5rem"
            v-for="voucher in voucherList"
            :key="voucher.id"
            @click="click(voucher)"
          >
            <div class="money" style="width: 4.4rem; line-height: 1.5rem">
              ￥
              <span class="num">{{ voucher.price }}</span>
            </div>
            <div class="text" style="width: 1.5rem; padding: 0.4rem 0.17rem 0 0.6rem; border-radius: 0 6px 6px 0;">
              <div class="data acea-row row-between-wrapper">
                <div
                  class="iconfont icon-xuanzhong1 font-color-red"
                  v-if="checked.indexOf(voucher.id) > -1"></div>
                <div class="iconfont icon-weixuanzhong" v-else></div>
              </div>
            </div>
          </div>
        </div>
        <div class="couponNo bg-color-red" @click="voucherNo">不使用抵用券</div>
      </div>
      <div v-if="!voucherList.length && loaded">
        <div class="pictrue">
          <img src="@assets/images/noCoupon.png" class="image" />
        </div>
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      :hidden="value === false"
      @click="close"
    ></div>
  </div>
</template>
<style scoped>
.coupon-list-window .iconfont {
  font-size: 0.4rem;
}
.couponNo {
  font-size: 0.3rem;
  font-weight: bold;
  color: #fff;
  width: 6.9rem;
  height: 0.86rem;
  border-radius: 0.43rem;
  text-align: center;
  line-height: 0.86rem;
  margin: 0.6rem auto;
}
</style>
<script>
import { getVouchersList } from "@api/order";
const NAME = "OrderSubmission"
export default {
  name: "voucherListWindow",
  props: {
    value: Boolean,
    checked: {
      type: Array,
      default: () => []
    },
    price: {
      type: [Number, String],
      default: undefined
    },
    cartInfo: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      voucherList: [],
      loaded: false,
      checkList: []
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) {
        this.getVouchers();
      }
    }
  },
  mounted: function() {
    this.getVouchers();
  },
  methods: {
    close: function() {
      this.$emit("input", false);
      this.$emit("close");
    },
    getVouchers() {
      getVouchersList().then(res => {
        this.voucherList = res.data;
        this.loaded = true;
      });
    },
    click(coupon) {
      if (this.checked.indexOf(coupon.id) > -1) {
        this.checkList.splice(
          this.checked.findIndex(item => {
            return coupon.id === item;
          }),
          1
        );
        this.$emit("checked", this.checkList);
      } else {
        this.checkList.push(coupon);
        this.$emit("checked", this.checkList);
      }
    },
    voucherNo: function() {
      this.checkList = [];
      this.$emit("checked", []);
      this.$emit("input", false);
    }
  }
};
</script>
